var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 11.6001V12.4001C4 15.0301 4 16.3451 4.72637 17.2302C4.85934 17.3922 5.00791 17.5408 5.16994 17.6737C6.05502 18.4001 7.37001 18.4001 10 18.4001C12.63 18.4001 13.945 18.4001 14.8301 17.6737C14.9921 17.5408 15.1407 17.3922 15.2736 17.2302C15.8349 16.5463 15.9625 15.6057 15.9915 14.0001L16.5267 14.2634C18.0834 15.0418 18.8618 15.431 19.4309 15.0792C20 14.7275 20 13.8573 20 12.1168V11.8834C20 10.1429 20 9.27269 19.4309 8.92096C18.8618 8.56922 18.0834 8.9584 16.5267 9.73675L15.9915 10.0001C15.9625 8.39452 15.8349 7.45394 15.2736 6.77004C15.1407 6.60801 14.9921 6.45944 14.8301 6.32646C13.945 5.6001 12.63 5.6001 10 5.6001C7.37001 5.6001 6.05502 5.6001 5.16994 6.32646C5.00791 6.45944 4.85934 6.60801 4.72637 6.77004C4 7.65512 4 8.97011 4 11.6001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVid);
export default __webpack_public_path__ + "static/media/vid.a829677cdd54e65493b47e22bbb64c1d.svg";
export { ForwardRef as ReactComponent };